import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { I18nService, TranslatePipe } from '@core/i18n-legacy';
import { OfferSelectComponent } from '@core/offers-smart-ui';
import type { OfferSelectOption } from '@core/offers-ui';
import type { DialogComponentI } from '@core/user-interface-legacy';
import {
  BoxComponent,
  ButtonComponent,
  DialogBodyComponent,
  DialogFooterComponent,
  DialogHeaderComponent,
  DialogRef,
  HeadingComponent,
} from '@core/user-interface-legacy';

export interface CandidateSharingOfferSelectDialogData {
  offerIds: number[];
  selectOptions: OfferSelectOption[];
  isBulk: boolean;
}

export type CandidateSharingOfferSelectDialogResult = number | null | undefined;

@Component({
  selector: 'rt-candidate-sharing-offset-select-dialog',
  templateUrl: './candidate-sharing-offer-select-dialog.component.html',
  styleUrls: ['./candidate-sharing-offer-select-dialog.component.less'],
  imports: [
    DialogHeaderComponent,
    DialogBodyComponent,
    DialogFooterComponent,
    ButtonComponent,
    TranslatePipe,
    BoxComponent,
    HeadingComponent,
    ReactiveFormsModule,
    OfferSelectComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CandidateSharingOfferSelectDialogComponent implements DialogComponentI<
  CandidateSharingOfferSelectDialogData,
  CandidateSharingOfferSelectDialogResult
> {
  private readonly cdRef = inject(ChangeDetectorRef);
  private readonly dialogRef =
    inject<DialogRef<CandidateSharingOfferSelectDialogComponent>>(DialogRef);
  private readonly i18n = inject(I18nService);

  public offerIds: number[];
  public selectOptions: OfferSelectOption[] = [];
  public formControl = new FormControl<number | null>(null);
  public heading: string;

  public setDialogData(data: CandidateSharingOfferSelectDialogData, triggerUpdate: boolean): void {
    this.offerIds = data.offerIds;
    this.selectOptions = data.selectOptions;
    this.formControl.setValue(!this.selectOptions[0]?.id ? null : +this.selectOptions[0].id);
    this.heading = this.i18n.translate(
      data.isBulk
        ? 'app.candidate.admin_select.share_with_team.job_select_dialog.dialog_heading_multiple'
        : 'app.candidate.admin_select.share_with_team.job_select_dialog.dialog_heading',
    );

    if (triggerUpdate) {
      this.cdRef.detectChanges();
    }
  }

  public cancel() {
    this.dialogRef.close(null);
  }

  public submit() {
    if (!this.formControl.value) {
      return;
    }

    this.dialogRef.close(this.formControl.value);
  }
}
